import { useEffect, useState } from "react";
import AccountDetails from "./components/AccountDetails/AccountDetails";
import Stats from "./components/Stats/Stats";
import TradingObjective from "./components/TradingObjective/TradingObjective";
import classes from "./Trading.module.css";
import RequestPayout from "./components/RequestPayout/RequestPayout";
import CloseIcon from "../../icon/CloseIcon";
import { GoShareAndroid } from "react-icons/go";
import BookMarkIcon from "../../icon/BookMarkIcon";
import DiscordShareIcon from "../../icon/DiscordShareIcon";
import XIcon from "../../icon/XIcon";
import RefreshIcon from "../../icon/RefreshIcon";
import ChallengeSteps from "../ChallengeSteps/ChallengeSteps";
import NextGen from "../NextGen/NextGen";
import HowItWorks from "../HowItWorks/HowItWorks";
import { useUser } from "../../context/UserContext";
import { env } from "../../constants/env";
import axios from "axios";
import { toast } from "react-toastify";
import { formatNumber } from "../../utilities/functions";
import DownloadOverlay from "./components/DownloadOverlay/DownloadOverlay";
import PurchaseOptions from "../PurchaseOptions/PurchaseOptions";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

export const stripePromise = loadStripe(env.publishableKey);

export const parsePrice = (priceStr) => {
  if (!priceStr) return 0; // handle null, undefined, or empty string
  const cleaned = priceStr.replace(/[^0-9.]/g, "");
  return cleaned ? parseFloat(cleaned) : 0;
};

const challengeList = [
  {
    image: "/bear-image.svg",
    alt: "bear",
  },
  {
    image: "/bull-image.svg",
    alt: "bull",
  },
];

const shareList = [
  {
    icon: <BookMarkIcon />,
    text: "Save Image",
    link: "",
  },
  {
    icon: <DiscordShareIcon />,
    text: "Share to Discord",
    link: "",
  },
  {
    icon: <XIcon />,
    text: "Share on X (twitter)",
    link: "",
  },
];

const ComponentContainer = ({
  title,
  children,
  showProfit,
  profitAmount,
  icon,
  innerIcon,
  onClickIcon = () => {},
}) => {
  return (
    <div className={classes.component}>
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex  gap-3">
          <div className="d-flex align-items-center gap-2 mb-3">
            <h2>{title}</h2>
            <div onClick={onClickIcon}>{innerIcon}</div>
          </div>{" "}
          {showProfit && (
            <div className={classes.profitContainer}>
              Profit : ${profitAmount}
            </div>
          )}
        </div>
        {icon}
      </div>
      {children}
    </div>
  );
};

const Trading = () => {
  const [explorer, setExplorer] = useState(false);
  const [payout, setPayout] = useState(false);
  const [profitAmount, setProfitAmount] = useState(100);
  const [withdrawalSuccess, setWithdrawalSuccess] = useState(false);
  const [showFlex, setShowFlex] = useState(false);
  const [seleteChallenge, setSeleteChallenge] = useState("bull");
  const [latestWithdrawal, setLatestWithdrawal] = useState(null);
  const [roi, setRoi] = useState("");
  const [payoutSize, setPayoutSize] = useState("");
  const [showOverlay, setShowOverlay] = useState(false);
  const [showPurchase, setShowPurchase] = useState(false);
  const [activeAccountType, setActiveAccountType] = useState("10K");
  const [accountTypeAmount, setAccountTypeAmount] = useState("$100.00");

  const { user, loading, fetchUserData } = useUser();

  console.log("ARE WE REALY GETTING USER? ", user);

  // const { accountType, userStage, initBalance } = user.account;

  const { accountType, userStage, initBalance } = user?.account || {};

  const fetchStats = () => {
    console.log("CLICKED");
    fetchUserData();
  };

  useEffect(() => {
    if (showFlex) {
      fetchLatestWithdrawal();
    }
  }, [showFlex]);

  const fetchLatestWithdrawal = async () => {
    try {
      const response = await fetch(`${env.apiUrl}/api/withdraw/latest`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.ok) {
        const data = await response.json();
        setLatestWithdrawal(data.latestWithdrawal);
        setRoi(data.roiOnChallengeFee);
        setPayoutSize(data.payoutSize);
      } else {
        console.error("Error fetching latest withdrawal");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleRequest = async () => {
    if (!payout && !withdrawalSuccess) {
      try {
        const response = await axios.post(
          `${env.apiUrl}/api/withdraw/check`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setPayout(true);
      } catch (err) {
        console.log(
          err.response?.data?.message ||
            "Something went wrong. Please try again."
        );
        toast.error(err.response?.data?.message);
      }
    }
  };

  if (loading) {
    return <p>Loading your dashboard...</p>;
  }

  if (!user) {
    return <p>Error loading user data.</p>;
  }

  return (
    <div className={`${classes.wrapper}`}>
      <DownloadOverlay
        setShowOverlay={(value) => setShowOverlay(value)}
        showOverlay={showOverlay}
      />

      {accountType === "Explorer" && (
        <>
          {showPurchase ? (
            <Elements stripe={stripePromise}>
              <PurchaseOptions
                setShowPurchase={(value) => setShowPurchase(value)}
                challengeTitle={`$${activeAccountType}`}
                challengePrice={parsePrice(accountTypeAmount)}
              />
            </Elements>
          ) : (
            <>
              <ChallengeSteps
                startButton
                setShowPurchase={(value) => setShowPurchase(value)}
                activeAccountType={activeAccountType}
                setActiveAccountType={(value) => setActiveAccountType(value)}
                setAccountTypeAmount={(value) => setAccountTypeAmount(value)}
              />
              <ComponentContainer title="Built For Next-Gen Traders">
                <NextGen setPayout={(value) => setPayout(value)} />
              </ComponentContainer>
              <HowItWorks className={classes.payoutPool} />
            </>
          )}
        </>
      )}
      {accountType !== "Explorer" && (
        <>
          <ComponentContainer title="Account Details">
            <AccountDetails
              setPayout={handleRequest}
              amount={initBalance}
              funded={userStage === 3}
              setShowOverlay={() => setShowOverlay(true)}
            />
          </ComponentContainer>

          {!payout && !withdrawalSuccess && (
            <>
              <ComponentContainer
                title="Stats"
                innerIcon={<RefreshIcon />}
                onClickIcon={fetchStats}
              >
                <Stats />
              </ComponentContainer>
              <ComponentContainer title="Trading Objective">
                <TradingObjective />
              </ComponentContainer>
            </>
          )}
          {payout && !withdrawalSuccess && (
            <ComponentContainer
              title="Request payout"
              showProfit={true}
              profitAmount={formatNumber(
                user.trackingStatistics?.statistics?.profitLoss
              )}
            >
              <RequestPayout
                profitAmount={
                  +formatNumber(user.trackingStatistics?.statistics?.profitLoss)
                }
                setWithdrawalSuccess={(value) => {
                  if (value === true) {
                    setWithdrawalSuccess(true);
                    setPayout(false);
                  }
                }}
              />
            </ComponentContainer>
          )}
          {!payout && withdrawalSuccess && (
            <ComponentContainer
              title="Request payout"
              icon={<CloseIcon onClick={() => setWithdrawalSuccess(false)} />}
            >
              <div className="d-flex align-items-center justify-content-center">
                <div
                  className={`d-flex flex-column align-items-center justify-content-center ${classes.successContainer}`}
                >
                  <img src="/targets.svg" />
                  <p>
                    Your withdrawal request has been submitted successfully!
                  </p>
                  <div
                    className={`d-flex align-items-center gap-1 ${classes.flexText}`}
                    role="button"
                    onClick={() => setShowFlex(true)}
                  >
                    <GoShareAndroid />
                    Flex
                  </div>
                </div>
              </div>
            </ComponentContainer>
          )}
          {showFlex && (
            <div
              className={`d-flex align-items-center justify-content-center ${classes.blurredOverlay}`}
            >
              <div className={`${classes.flexModal}`}>
                <div
                  className={`${classes.flexModalHeader} d-flex align-items-center justify-content-between w-100`}
                >
                  <div className={classes.logoContainer}>
                    <img src="/PROPTRADING.FUN-LOGO.svg" alt="logo" />
                  </div>

                  <CloseIcon
                    onClick={() => {
                      setShowFlex(false);
                      setWithdrawalSuccess(false);
                    }}
                    size={20}
                  />
                </div>
                <div className={`row mx-0 ${classes.flexModalBody}`}>
                  <div className={`col-lg-8`}>
                    <div className={classes.infoInnerWrapper}>
                      <div
                        className={`d-flex flex-column justify-content-between ${classes.infoContainer}`}
                      >
                        <div>
                          <h4>ROI On Challenge Fee</h4>
                          <h1>{roi}</h1>
                        </div>
                        <div>
                          <h4 className={classes.sizeText}>Payout Size</h4>
                          <h3>${payoutSize}</h3>
                        </div>
                      </div>
                      <div
                        className={`${classes.imagesContainer} float-lg-end`}
                      >
                        <img src="/bg-image.svg" alt="background" />
                        <div className={classes.bearImageContainer}>
                          <img
                            src={`/${
                              seleteChallenge === "bull" ? "bull" : "bear"
                            }.svg`}
                            about="bear"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${classes.customizeWrapper} col-lg-4`}>
                    <div className={`${classes.customizeContainer}`}>
                      <label>Customize your text</label>
                      <textarea value="Hey guys checkout my payout size! Join Proptrading.fun today and keep 100% of your profits!" />
                      <div className="mt-4">
                        <label>Overlay</label>
                        <div className="row">
                          {challengeList.map((item, i) => (
                            <div className="col-6" key={i}>
                              <div
                                className={`d-flex align-items-center justify-content-center ${
                                  classes.bearContainer
                                } ${
                                  seleteChallenge === item.alt
                                    ? classes.activeChallenge
                                    : ""
                                }`}
                                role="button"
                                onClick={() => setSeleteChallenge(item.alt)}
                              >
                                <img src={item.image} alt={item.alt} />
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="d-flex flex-column gap-2 mt-4">
                          {shareList.map((item, i) => (
                            <div
                              key={i}
                              className={`d-flex align-items-center justify-content-center gap-2 ${classes.shareButton}`}
                              role="button"
                            >
                              {item.icon}
                              <div>{item.text}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Trading;
